module.exports = __webpack_public_path__ + "img/cz.1a849ea4.png";